module.exports = __webpack_public_path__ + "media/images/Logo_Tavour_White/Logo_Tavour_White@2x-d69d50284dc675b1ea671ff3345c4bc8.png";